// extracted by mini-css-extract-plugin
module.exports = {"root":"Cineflex_root__1ZVdy"};